export const SET_APP_VERSION = "SET_APP_VERSION";
export const SET_FLAVOUR = "SET_FLAVOUR";
